import { render, staticRenderFns } from "./efItem8.vue?vue&type=template&id=515d3629&lang=pug&"
import script from "./efItem8.vue?vue&type=script&lang=js&"
export * from "./efItem8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports